<template>
    <div>

        <b-modal id="add-effective-date" title="Ekle" no-close-on-esc no-close-on-backdrop>
            <tire-reference-model-add-effective-date v-model="effectiveDate"></tire-reference-model-add-effective-date>
            <template #modal-footer>
                <button class="btn btn-primary" v-on:click="addEffectiveDate">Ekle</button>
            </template>
        </b-modal>

        <div class="row">
            <div class="col-12">
                <div class="pr-2 pl-2 pt-2">
                    <label class="form-label">Lastik Referans Model Adı</label>
                    <input type="text" class="form-control" placeholder="Lastik Referans Model Adı" v-model="value.Name"/>
                </div>
                <div class="pr-2 pl-2 pt-2">
                    <label class="form-label">Lastik Ebadı</label>
                    <v-select-list v-model="tireSize" placeholder="Lastik Ebadı" label="Size" :options="tireSizes"></v-select-list>
                </div>
                <div class="col-12 pl-2 pr-2 pt-1">
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Ön Dingilleri</th>
                                        <th>Arka Dingilleri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in 4" :key="item">
                                        <td>
                                            <b-form-checkbox v-model="frontAxles[index].active" v-on:change="updateTireReferenceModelAxle" :id="'front-'+index" :key ="'front-'+index">
                                                {{(index + 1)}}. Dingil
                                            </b-form-checkbox>
                                        </td>
                                        <td>
                                            <b-form-checkbox v-model="backAxles[index].active" v-on:change="updateTireReferenceModelAxle" :id="'back-'+index" :key ="'back-'+index">
                                                {{(index + 1)}}. Dingil
                                            </b-form-checkbox>
                                        </td>
                                    </tr> 
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <v-table    ref="table"
                            :add-callback="createNew"
                            name="tire-reference2"
                            with-items
                            :settings="false"
                            :fields="fields"
                            :buttons="buttons"
                            :items="value.EffectiveDates"></v-table>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import TireReferenceModelAddEffectiveDate from "./TireReferenceModelAddEffectiveDate"
import moment from "moment"
export default {
    components:{
        BFormCheckbox,
        TireReferenceModelAddEffectiveDate
    },
    props:{
        tireSizes:Array,
        value:Object,
        axles:Array,
    },
    data(){
        return{
            effectiveDate:{
                Id:null,
                Price:null,
                EffectivePriceDate:null,
                EffectivePriceVisual:null,
            },
            fields:[
                {name:"Fiyat",key:"Price",thClass:"w-50",tdClass:'text-nowrap'},
                {name:"Başlangıç Tarihi",key:"EffectivePriceDateVisual",thClass:"w-50",tdClass:'text-nowrap'},
            ],
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
        }
    },
    methods:{
        clearForm(){
            this.effectiveDate.Id = null
            this.effectiveDate.Price = null
            this.effectiveDate.EffectivePriceDate = null
            this.effectiveDate.EffectivePriceVisual = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('add-effective-date')
        },
        addEffectiveDate(){
            let clone = structuredClone(this.effectiveDate)
            clone.EffectivePriceDateVisual = moment(clone.EffectivePriceDate).locale("tr").format('L')
            this.value.EffectiveDates.push(clone)
            this.$hideModal('add-effective-date')
        },
        delete(item,key,index){
            this.$delete(this.value.EffectiveDates,index)
        },
        updateTireReferenceModelAxle(){
            this.$set(this.value,"TireReferenceModelAxleInfos",this.c_axles)
        },
    },
    computed:{
        backAxles(){
            return this.axles.filter(item => item.PartLocation == "BACK")
        },
        frontAxles(){
            return this.axles.filter(item => item.PartLocation == "FRONT")
        },
        c_axles(){
            return this.axles.filter(a=> a.active).map(a=>{
                return {
                    PartLocation:a.PartLocation,
                    AxleOrder:a.AxleOrder
                }
            })
        },
        tireSize:{
            get:function(){
                return this.tireSizes.find(s=>s.Id==this.value.TireSizeId)
            },
            set:function(value){
                this.value.TireSizeId = value?.Id || this.value.TireSizeId
            }
        }
    }
}
</script>

<style>

</style>